// SettingsPreferences.jsx
import React from 'react';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const SettingsPreferencesRoute = () => {
  return (
    <UniversalComponent
      filename="Container_ProfilePreferences"
      importer={
        /* #__LOADABLE__ */ () => import('../container/ProfilePreferences.js')
      }
    />
  );
};

export default SettingsPreferencesRoute;
